import React, {
  useState,
  useEffect,
  Suspense,
  useMemo,
  useRef,
  useCallback,
} from "react";
import Page from "components/Page";
import { withTranslation } from "react-i18next";
import styles from "./AddEvent.module.scss";
import "./AddEvent.scss";
import CustomDropdown from "components/Dropdown";
import TimePicker from "rc-time-picker";
import { Row, Col } from "reactstrap";
import AddRolesModal from "./components/AddRolesModal";
import moment from "moment";
import { updateTimeToUpcomingQuater, testRegexCheck, getDay } from "utils";
import constants, {
  notifyAttendeesOptions,
  notifyAttendeesOptionsForAllDayEvent,
  eventSchedulingTabStatus,
} from "../../../constants";
import CustomInputTag from "./components/CustomInputTag";
import {
  useStaffDesignation,
  useCreateSchedulerEventMutation,
  useCreateSchedulerEventCheckingAvailabilityMutation,
} from "repositories/scheduler-repository";
import toast from "react-hot-toast";
import Loader from "components/Loader";
import Text from "components/Text";
import QuestimIcon from "assets/images/question_mark.svg";
import ConfirmationPopup from "./components/ConfirmationPopup";
import { Nav, NavItem, NavLink, TabContent, TabPane } from "reactstrap";
import SchedulingAssistant from "assets/images/scheduling_assistant.svg";
import SelectStaffMemberModal from "./components/SelectStaffMemberModal";
import SchedulingAssistantDetails from "./SchedulingAssistant/SchedulingAssistantDetails";
import ToggleSwitch from "components/ToggleSwitch";
import InviteesPopup from "../EventDetails/components/Modals/InviteesPopup";
import RolePopup from "./components/RolePopup";
import SelectOfficeModal from "./components/SelectOfficeModal";
import SchedulerAssistantInfoModal from "./components/schedulerAssistantInfoModal";
import { addEditEventsConst } from "./addEvents.constants";
import {
  addRemoveUserOrRoleError,
  arrayIntoString,
  getLocalTimeZoneCode,
  getRepeatMessage,
  handleChangeValidation,
  handleSubmitValidation,
  MoreTagsFunction,
  setterCustomSchduler,
  setterPublishOffices,
} from "./addEvents.functions";
import useEventDateTimeSync from "./hooks/useEventDateTimeSync";
import RepeatEventDropDowns from "./RepeatEventDropDowns";
import ReactDatePickerCommon from "components/ReactDatePickerCommon";
import { showTime } from "../Scheduler/OfficeSchedulerTab/SubTabs/EventsShiftsTab";
import InfoIcon from "assets/images/info_black-tooltip.svg";
import ErrorIcon from "assets/images/ico_alert.svg";
import CircleIcon from "assets/images/check_circle.svg";
import {
  currentDateDisableAccToEndTime,
  disabledDatesForCalendar,
  everyDatesCheckExceptCustomFunction,
} from "../Scheduler/components/Modals/repeatEvent.functions";
import { useAccountOwnerCommon } from "lib/Context/AccountOwner";

const AddEvent = ({
  t,
  history,
  isInsideModal,
  location,
  selectedOwnerId,
  onConfirm,
}) => {
  const {
    effectiveOwnerId,
    isOwner,
    isStaff,
    dataAccessValues,
    getIdToCheckOwnerChange,
  } = useAccountOwnerCommon();
  const loggedInUserId = useMemo(
    () => selectedOwnerId ?? effectiveOwnerId,
    [effectiveOwnerId, selectedOwnerId],
  );
  useEffect(() => {
    if (!effectiveOwnerId) return;
    if (getIdToCheckOwnerChange()) {
      if (window.history.length > 1) {
        history.goBack();
      } else {
        history.push(constants.routes.scheduler.calendar);
      }
    }
  }, [effectiveOwnerId]);
  const today = useMemo(
    () => moment(location?.state?.date).toDate() || moment().toDate(),
    [location?.state?.date],
  );
  const [userIds, setUserIds] = useState([]);
  const [publishAsEvent, setPublishAsEvent] = useState("");
  const [nonInviteesPublish, setNonInviteesPublish] = useState("");
  const [selectOfficeForEvent, setSelectOfficeForEvent] = useState(null);
  const [eventOrShiftTab, setCreateOrShiftTab] = useState(
    () => isOwner || (isStaff && dataAccessValues?.isAdmin),
  );
  const [exclude, setExclude] = useState({
    IsExcludeHoliday: false,
    IsExcludeLeave: false,
  });

  const eventCapsKey = useMemo(
    () => ({
      eventOrShift: t(`accountOwner.${eventOrShiftTab ? "shift" : "event"}Tab`),
      saveOrPublish: publishAsEvent === "saveDraft" ? "Save" : "Publish",
    }),
    [eventOrShiftTab, publishAsEvent],
  );
  const eventKey = useMemo(
    () => ({
      eventOrShift: eventCapsKey.eventOrShift.toLowerCase(),
      saveOrPublish: eventCapsKey.saveOrPublish,
    }),
    [eventCapsKey],
  );
  const filteredUserIds = useMemo(
    () =>
      userIds?.filter((e) => e.IsDeleted === false || e.isDeleted === false),
    [userIds],
  );
  const userSelected = useRef(false);
  const preferredOption = useMemo(() => {
    const zeroUserCheck = filteredUserIds.length === 0;
    const values = {
      dropdown: addEditEventsConst.dropdown(t, zeroUserCheck, eventKey),
      otherOptions: addEditEventsConst.otherOptions(t, zeroUserCheck),
    };
    if (
      !publishAsEvent ||
      values.dropdown.every((res) => res.id !== publishAsEvent)
    ) {
      setPublishAsEvent(values.dropdown[0].id);
    }
    if (filteredUserIds.length && !userSelected.current) {
      userSelected.current = true;
      setPublishAsEvent(values.dropdown[0].id);
    } else if (userSelected.current && !filteredUserIds.length) {
      userSelected.current = false;
    }
    if (
      !nonInviteesPublish ||
      values.otherOptions.every((res) => res.id !== nonInviteesPublish)
    ) {
      setNonInviteesPublish(values.otherOptions[0].id);
    }
    return values;
  }, [filteredUserIds, publishAsEvent, nonInviteesPublish, eventKey]);

  const goBack = (qry) => {
    if (qry) {
      history.push(constants.routes.scheduler.calendar + (qry ?? ""));
      return;
    }
    history.push(constants.routes.scheduler.calendar);
  };

  const [issaveRolesModalOpen, setIsSaveRolesModalOpen] = useState(false);
  const [isSelectStaffMemberModalOpen, setIsSelectStaffMemberModalOpen] =
    useState(false);
  const [isSelectOfficeModalOpen, setIsSelectOfficeModalOpen] = useState("");
  const [
    isScheduleAssistantInfoModalOpen,
    setIsScheduleAssistantInfoModalOpen,
  ] = useState(false);
  const [title, setTitle] = useState("");
  const [isAutoMatically, setIsAutoMatically] = useState(false);
  const [repeatedType, setRepeatedType] = useState(1);
  const [repeatedEndDate, setRepeatedEndDate] = useState(
    moment(today).add(3, "month").toDate(),
  );
  const [eventLocation, setEventLocation] = useState("");
  const [blockForPatient, setBlockForPatient] = useState(false);
  const [note, setNote] = useState("");
  const [officeIdForNonInvitee, setOfficeIdForNonInvitee] = useState([]);
  const [nonInvitePopup, setNonInvitePopup] = useState(false);
  const [designationIds, setDesignationIds] = useState([]);
  const [eventTags, setEventTags] = useState([]);
  const [errors, setErrors] = useState({});
  const [loader, setLoader] = useState(false);
  const [confirmPopup, setConfirmPopup] = useState(false);
  const [notifyDuration, setNotifyDuration] = useState(
    notifyAttendeesOptions[2]?.id,
  );
  const [activeTab, setActiveTab] = useState(() => {
    if (
      location?.state &&
      (location.state.fromSchedulingAssistant ||
        location.state.setSchedulingAssistantTab ||
        location.state?.fromScreen === "schedulingAssistant")
    ) {
      return eventSchedulingTabStatus.schedulingAssistant;
    }
    return eventSchedulingTabStatus.event;
  });
  const eventTabCheck = useMemo(() => !eventOrShiftTab, [eventOrShiftTab]);
  const [invitePopupOpen, setInvitePopupOpen] = useState(false);
  const [invitePopupPosition, setInvitePopupPosition] = useState({
    top: 0,
    right: 0,
  });
  const [rolePopupOpen, setRolePopupOpen] = useState(false);
  const [selectedRoleList, setSelectedRoleList] = useState([]);
  const [repeatedTypeFrequency, setRepeatedTypeFrequency] = useState(1);
  const [repeatedTypeEvery, setRepeatedTypeEvery] = useState(1);
  const [schedule, setSchedule] = useState([
    today.getDay() === 0 ? 7 : today.getDay(),
  ]);
  const [selectionType, setSelectionType] = useState(true);
  const [selectedWeek, setSelectedWeek] = useState(() => {
    const startOfMonth = moment(today).clone().startOf("month");
    return moment(today).diff(startOfMonth, "weeks") + 1;
  });
  const [selectedDay, setSelectedDay] = useState(
    today.getDay() === 0 ? 7 : today.getDay(),
  );
  const [isDaySwitchOn, setIsDaySwitchOn] = useState(false);
  const [selectedSlotDate, setSelectedSlotDate] = useState([today.getDate()]);
  const [selectedMonths, setSelectedMonths] = useState([today.getMonth() + 1]);
  const [selectedStaff, setSelectedStaff] = useState([]);
  const {
    eventDate,
    setEventDate,
    startTime,
    setStartTime,
    endTime,
    setEndTime,
    isAllDayEvent,
    setIsAllDayEvent,
    endTimeError,
    handleDateTimeChange,
    startOrEndTimeValue,
  } = useEventDateTimeSync({ t, initialEventDate: today, setErrors });

  const manageTab = (tab) => {
    setActiveTab(tab);
  };

  const closeModal = () => setConfirmPopup(false);

  const repeatOptions = useMemo(
    () => addEditEventsConst.repeatedOptions(t),
    [],
  );

  const { isLoading: loadinStaffData, data: roleData } = useStaffDesignation();
  const createSchedulerEventMutation = useCreateSchedulerEventMutation();
  const CreateSchedulerEventCheckingAvailabilityMutation =
    useCreateSchedulerEventCheckingAvailabilityMutation();
  useEffect(() => {
    setUserIds([]);
  }, []);

  useEffect(() => {
    if (isAllDayEvent) {
      setNotifyDuration(
        notifyAttendeesOptionsForAllDayEvent(eventOrShiftTab)[3]?.id,
      );
    } else {
      setNotifyDuration(notifyAttendeesOptions[2]?.id);
    }
  }, [isAllDayEvent]);

  useEffect(() => {
    const designationRole =
      designationIds?.filter((e) => e.IsDeleted === false) || [];

    if (designationRole.length === 0) {
      setSelectedRoleList([]);
      return;
    }

    const allDesignations =
      roleData?.flatMap((data) => data.designations || []) || [];

    const matchedDesignations = designationRole
      .map((role) =>
        allDesignations.find((item) => item.id === role?.designationsId),
      )
      .filter(Boolean);

    setSelectedRoleList(matchedDesignations);
  }, [designationIds, roleData]);

  useEffect(() => {
    setUserIds(selectedStaff);
  }, [selectedStaff]);
  useEffect(() => {
    if (selectedStaff.length) {
      const firstOfficeId = selectedStaff[0]?.officeId;
      for (let i = 1; i < selectedStaff.length; i++) {
        if (selectedStaff[i].officeId !== firstOfficeId) {
          setSelectedStaff([]);
          break;
        }
      }
    }
    setErrors({});
  }, [eventOrShiftTab]);

  useEffect(() => {
    const locationSelectedStaff =
      location?.state?.selectedStaff ||
      location?.state?.schedulingAssistantState?.selectedStaff;
    if (locationSelectedStaff) {
      setSelectedStaff(locationSelectedStaff);
    }
    const locationEventDate =
      location?.state?.eventDate ||
      location?.state?.schedulingAssistantState?.currentDate;
    if (locationEventDate) {
      setEventDate(locationEventDate);
    }
    // If coming from Scheduling Assistant, set the tab
    if (
      location?.state &&
      (location.state.fromSchedulingAssistant ||
        location.state.setSchedulingAssistantTab ||
        location?.state?.fromScreen === "schedulingAssistant")
    ) {
      setActiveTab(eventSchedulingTabStatus.schedulingAssistant);
    }
    // Add more state restores as needed
  }, []);

  const handleChange = (key, value) => {
    handleChangeValidation({
      key,
      value,
      errors,
      t,
      setIsAllDayEvent,
      setStartTime,
      setEndTime,
      endTime,
      updateTimeToUpcomingQuater,
      startTime,
      setErrors,
    });
  };

  const afterChanges = useRef(true);
  useEffect(() => {
    if (afterChanges.current) {
      afterChanges.current = !filteredUserIds.length && !designationIds.length;
      return;
    }

    setErrors((prev) => {
      addRemoveUserOrRoleError({
        filteredUserIds,
        designationIds,
        errorsData: prev,
        t,
      });
      return { ...prev };
    });
  }, [filteredUserIds, designationIds]);
  const isValidEvent = () => {
    if (
      publishAsEvent !==
      preferredOption.dropdown[preferredOption.dropdown.length - 1].id
    ) {
      const check = handleSubmitValidation({
        errors,
        eventCheck: !eventOrShiftTab,
        title,
        t,
        isAllDayEvent,
        startTime,
        endTime,
        filteredUserIds,
        designationIds,
        repeatedType,
        preferredOption,
        eventDate,
        repeatedEndDate,
        publishAsEvent,
        nonInviteesPublish,
        officeIdForNonInvitee,
        setErrors,
      });
      return check;
    }
    return true;
  };

  const saveEvent = (confirmOpen) => {
    if (isValidEvent()) {
      if (eventOrShiftTab && !filteredUserIds.length && !confirmOpen) {
        setIsSelectOfficeModalOpen("addOffice");
      } else if (isInsideModal) {
        handleConfirm();
      } else {
        setConfirmPopup(true);
      }
    } else {
      scrollToError();
    }
  };

  const canAddShift = useMemo(
    () => isOwner || (isStaff && dataAccessValues?.isAdmin),
    [isOwner, isStaff, dataAccessValues],
  );
  const filteredDesignationIds = useMemo(
    () => designationIds.filter((res) => !res.isDeleted && !res.IsDeleted),
    [designationIds],
  );
  const excludeCheckBox = useMemo(
    () => [
      { heading: t("scheduler.excludeHolidays"), key: "IsExcludeHoliday" },
      { heading: t("scheduler.excludeLeaves"), key: "IsExcludeLeave" },
    ],
    [],
  );
  const {
    visibilityCardForAvailability,
    conflictingData,
    anyRepeatTypeActive,
    stringValues,
  } = useMemo(() => {
    const anyRepeatTypeActive =
      repeatedType !== addEditEventsConst.repeatedOptionsValues.never;
    const conflictingData =
      CreateSchedulerEventCheckingAvailabilityMutation.data;
    return {
      visibilityCardForAvailability:
        (CreateSchedulerEventCheckingAvailabilityMutation.data ||
          anyRepeatTypeActive) &&
        filteredUserIds?.length > 0 &&
        !!startTime &&
        !!endTime,
      conflictingData,
      anyRepeatTypeActive,
      stringValues: anyRepeatTypeActive
        ? "warning"
        : conflictingData?.isConflicting
          ? "error"
          : "success",
    };
  }, [
    CreateSchedulerEventCheckingAvailabilityMutation.data,
    filteredUserIds?.length,
    startTime,
    endTime,
    repeatedType,
  ]);

  useEffect(() => {
    if (anyRepeatTypeActive) return;
    if (!filteredUserIds.length || !startTime || !endTime || !loggedInUserId)
      return;
    const timer = setTimeout(() => {
      CreateSchedulerEventCheckingAvailabilityMutation.mutate({
        Users: filteredUserIds.map((res) => ({
          UserId: res.userId,
          OfficeId: res.officeId,
        })),
        OwnerId: loggedInUserId,
        IsAllDayEvent: isAllDayEvent,
        EventDate: moment(eventDate).format("YYYY-MM-DD"),
        EventStartTime: startOrEndTimeValue(startTime, "startOf"),
        EventEndTime: startOrEndTimeValue(endTime, "endOf"),
        IsForEvent: !eventOrShiftTab,
        IsForShift: eventOrShiftTab,
      });
    }, 100);
    return () => {
      clearTimeout(timer);
    };
  }, [
    loggedInUserId,
    filteredUserIds,
    isAllDayEvent,
    startTime,
    endTime,
    anyRepeatTypeActive,
    eventOrShiftTab,
    eventDate,
  ]);

  const buildCreateEventParams = (isDraft, timeZone) => ({
    OwnerId: loggedInUserId,
    Title: title,
    Date: moment(eventDate).format("YYYY-MM-DDTHH:mm"),
    StartTime: startOrEndTimeValue(startTime, "startOf"),
    EndTime: startOrEndTimeValue(endTime, "endOf"),
    IsAllDayEvent: isAllDayEvent,
    RepeatedType: +repeatedType,
    isShift: eventOrShiftTab,
    RepeatedDay: moment(eventDate).isoWeekday(),
    RepeatedEndDate: anyRepeatTypeActive
      ? moment(repeatedEndDate).format("YYYY-MM-DDTHH:mm")
      : null,
    Location: eventLocation,
    Note: note,
    PublishAsEvent: publishAsEvent === "allowInvitees",
    isDraft,
    eventEmployees: userIds,
    EventRoles: designationIds,
    EventTags: eventOrShiftTab ? [] : eventTags,
    CreatedAt: moment().format("YYYY-MM-DDTHH:mm"),
    ReminderBeforeInMins: notifyDuration,
    UtcOffsetInMinutes: moment().utcOffset(),
    BlockForPatient: eventOrShiftTab ? false : blockForPatient,
    timezoneCode: timeZone.code,
    timezoneId: timeZone.timeZoneId,
    IsExcludeLeave: anyRepeatTypeActive && exclude.IsExcludeLeave,
    IsExcludeHoliday: anyRepeatTypeActive && exclude.IsExcludeHoliday,
  });

  const applyCreateModeFields = (params) => {
    if (eventOrShiftTab) {
      delete params.Title;
      delete params.Location;
      delete params.Note;
      params.officeId = selectOfficeForEvent?.id ?? userIds[0].officeId;
      return;
    }
    params.IsAutoApprove = isAutoMatically;
  };

  const navigateAfterCreate = (response) => {
    if (onConfirm) {
      onConfirm(true);
      return;
    }
    if (response.data?.data?.firstOccurrenceDate) {
      goBack(
        `?${showTime}=` +
          new Date(response.data?.data?.firstOccurrenceDate).valueOf(),
      );
      return;
    }
    goBack();
  };

  const handleConfirm = async () => {
    setLoader(true);
    const isDraft = publishAsEvent === "saveDraft";
    const timeZone = getLocalTimeZoneCode();
    try {
      const params = buildCreateEventParams(isDraft, timeZone);
      applyCreateModeFields(params);
      setterCustomSchduler({
        params,
        repeatedType,
        repeatedTypeFrequency,
        repeatedTypeEvery,
        selectionType,
        schedule,
        selectedSlotDate,
        selectedWeek,
        selectedDay,
        selectedMonths,
        isDaySwitchOn,
      });
      setterPublishOffices({
        preferredOption,
        userIds,
        publishAsEvent,
        nonInviteesPublish,
        params,
        officeIdForNonInvitee,
      });
      const response = await createSchedulerEventMutation.mutateAsync(params);
      toast.success(t("staff.eventAdded", eventCapsKey));
      setLoader(false);
      closeModal();
      navigateAfterCreate(response);
    } catch (e) {
      toast.error(e.message);
      setLoader(false);
    }
  };

  const scrollToError = () => {
    setTimeout(() => {
      const error = document.getElementsByClassName("error-msg");
      if (error?.length) {
        error[0].scrollIntoView({
          behavior: "smooth",
          block: "center",
          inline: "start",
        });
      }
    }, 1000);
  };

  const clearAllTags = () => {
    setEventTags([]);
  };

  const handlePopupToggle = (event, setter) => {
    event.stopPropagation();
    setInvitePopupPosition({
      top: 40,
      left: 40,
    });
    setter((prev) => !prev);
  };
  const isCustom = useMemo(
    () => repeatedType === addEditEventsConst.repeatedOptionsValues.custom,
    [repeatedType],
  );
  const getSelectedDayNames = useCallback(() => {
    if (schedule.length === 0) return "";
    const dayMap = addEditEventsConst.dayMap;
    const sortedDays = schedule.sort((a, b) => a - b).map((val) => dayMap[val]);

    return arrayIntoString(sortedDays);
  }, [schedule]);

  const repeatMessagesDisplay = useMemo(() => {
    if (isCustom) {
      return getRepeatMessage({
        repeatedTypeEvery,
        repeatedTypeFrequency,
        repeatOptionsFrequency: addEditEventsConst.repeatOptionsFrequency,
        getSelectedDayNames,
        selectionType,
        selectedSlotDate,
        selectedWeek,
        selectedDay,
        selectedMonths,
        isDaySwitchOn,
        isFromBusySlot: false,
        isShift: eventOrShiftTab,
      });
    }
    return null;
  }, [
    repeatedTypeEvery,
    repeatedTypeFrequency,
    selectionType,
    selectedSlotDate,
    selectedWeek,
    selectedDay,
    selectedMonths,
    isDaySwitchOn,
    eventOrShiftTab,
    getSelectedDayNames,
    repeatedType,
  ]);
  const startDay = useMemo(
    () => getDay(eventDate ? new Date(eventDate) : new Date()),
    [eventDate],
  );

  const everyDatesCheckExceptCustom = useMemo(() => {
    const eventDetails = {
      repeatedType,
      date: eventDate,
      endTime: endTime,
      repeatedEndDate,
      isAllDayEvent: true,
      CustomRepeatPattern: {},
      customRepeatPattern: {},
    };
    setterCustomSchduler({
      params: eventDetails,
      repeatedType,
      repeatedTypeFrequency,
      repeatedTypeEvery,
      selectionType,
      schedule,
      selectedSlotDate,
      selectedWeek,
      selectedDay,
      selectedMonths,
      isDaySwitchOn,
    });
    if (eventDetails.CustomRepeatPattern) {
      const values = eventDetails.CustomRepeatPattern;
      eventDetails.customRepeatPattern = {
        unit: values.Unit,
        interval: values.Interval,
        daysOfWeek: values?.DaysOfWeek?.map((res) => ({
          dayOfWeek: res,
        })),
        daysOfMonth: values?.DaysOfMonth?.map((res) => ({ day: res })),
        monthsOfYear: values?.MonthsOfYear?.map((res) => ({ month: res })),
        monthWeekNumber: values?.monthWeekNumber || 1, // default value will be 1
      };
    }
    return {
      eventDetails,
      values: everyDatesCheckExceptCustomFunction(eventDetails),
    };
  }, [
    repeatedType,
    eventDate,
    repeatedEndDate,
    endTime,
    repeatedTypeFrequency,
    repeatedTypeEvery,
    selectionType,
    schedule,
    selectedSlotDate,
    selectedWeek,
    selectedDay,
    selectedMonths,
    isDaySwitchOn,
    isAllDayEvent,
  ]);

  const disabledDates = ({ date }) => {
    if (repeatedType === addEditEventsConst.repeatedOptionsValues.never) {
      return moment(date).isSame(moment(eventDate).startOf("day"));
    } else if (
      repeatedType === addEditEventsConst.repeatedOptionsValues.everyDay
    ) {
      return currentDateDisableAccToEndTime(
        everyDatesCheckExceptCustom.eventDetails,
        moment(date).format("YYYY-MM-DD"),
        moment(date).isSameOrAfter(moment(eventDate).startOf("day")),
      );
    }

    if (
      moment(date).isBefore(
        moment(everyDatesCheckExceptCustom.eventDetails.date).startOf("day"),
      )
    ) {
      return false;
    }

    return !disabledDatesForCalendar(
      everyDatesCheckExceptCustom.eventDetails,
      new Date(date),
      startDay,
      everyDatesCheckExceptCustom.values.get(moment(date).format("YYYY-MM")) ??
        [],
    );
  };
  return (
    <Page
      onBack={() => {
        goBack();
      }}
      hideBackButton={isInsideModal}
      className="scheduler-page w-100"
      title={
        <>
          {t(
            canAddShift
              ? "accountOwner.addNewEventShift"
              : "accountOwner.addNewEvent",
          )}
        </>
      }
      actionButton={
        isInsideModal ? null : (
          <button
            type="button"
            className={styles.question_btn}
            onClick={() => setIsScheduleAssistantInfoModalOpen(true)}
          >
            <img src={QuestimIcon} alt="QuestimIcon" />
            <p className="m-0">{t("navbar.help")}</p>
          </button>
        )
      }
    >
      <div
        className={isInsideModal ? styles["scroll-view"] : ""}
        style={
          isInsideModal ? { maxHeight: `${window.innerHeight - 250}px` } : {}
        }
      >
        {canAddShift && (
          <div
            className={
              styles["toggle-switch"] +
              " page-title-selection mt-2" +
              (isInsideModal ? " border border-0 shadow-none ps-reset" : "")
            }
          >
            <span>{t("accountOwner.shiftTab")}</span>
            <ToggleSwitch
              label="searchDatabase"
              value={!eventOrShiftTab}
              onChange={(e) => {
                setCreateOrShiftTab(!e.target.checked);
              }}
            />
            <span>{t("accountOwner.eventTab")}</span>
          </div>
        )}
        {(loader || loadinStaffData) && <Loader />}
        <div
          className={"margin30 pt-2" + (isInsideModal ? "" : " form-wrapper")}
        >
          <div className={`common-tabs scheduler-tabs`}>
            {isInsideModal ? null : (
              <Nav tabs>
                <NavItem>
                  <NavLink
                    className={
                      activeTab === eventSchedulingTabStatus.event
                        ? "active"
                        : ""
                    }
                    onClick={() => manageTab(eventSchedulingTabStatus.event)}
                  >
                    {t(
                      `accountOwner.${eventOrShiftTab ? "shift" : "event"}Tab`,
                    )}
                  </NavLink>
                </NavItem>
                <NavItem>
                  <NavLink
                    className={
                      activeTab === eventSchedulingTabStatus.schedulingAssistant
                        ? "active"
                        : ""
                    }
                    onClick={() =>
                      manageTab(eventSchedulingTabStatus.schedulingAssistant)
                    }
                  >
                    {t("scheduler.schedulingAssistant")}
                  </NavLink>
                </NavItem>
              </Nav>
            )}
            <TabContent
              activeTab={activeTab}
              className={!isInsideModal ? "scheduler-tabs-calendar" : ""}
            >
              <Suspense fallback={<Loader />}>
                <TabPane tabId={1}>
                  {activeTab === eventSchedulingTabStatus.event && (
                    <div
                      className={
                        isInsideModal
                          ? ""
                          : styles.scheduling_assistant_image_wrapper
                      }
                    >
                      <div className={styles.scheduling_event_section}>
                        <div
                          className={
                            isInsideModal
                              ? "w-100 pe-xxs"
                              : styles["add-event-form"]
                          }
                        >
                          {eventTabCheck && (
                            <div className="c-field">
                              <label>{t("title")}</label>
                              <textarea
                                className={
                                  "c-form-control" +
                                  (isInsideModal ? " h-auto" : "")
                                }
                                placeholder={t("form.placeholder1", {
                                  field: t("title"),
                                })}
                                name="title"
                                maxLength="400"
                                value={title}
                                onChange={(e) => {
                                  handleChange("title", e.currentTarget.value);
                                  setTitle(e.currentTarget.value);
                                }}
                              ></textarea>
                              {errors.title && (
                                <span className="error-msg">
                                  {errors.title}
                                </span>
                              )}
                            </div>
                          )}

                          <div className="c-field">
                            <div className={" d-flex justify-content-between "}>
                              <label className={styles["c-field-label"]}>
                                <span>{t("accountOwner.staffTxt")}</span>
                              </label>
                              <span
                                className={`${styles.link_new} link-btn`}
                                onClick={() => {
                                  setIsSelectStaffMemberModalOpen(true);
                                }}
                              >
                                {t("accountOwner.selectStaff")}
                              </span>
                            </div>
                            <div
                              className="c-form-control"
                              style={{ position: "relative" }}
                            >
                              {selectedStaff?.length === 0 ? (
                                <span>{t("accountOwner.noStaffSelected")}</span>
                              ) : (
                                <MoreTagsFunction
                                  value={selectedStaff?.filter(
                                    (e) => e?.isDeleted === false,
                                  )}
                                  styles={styles.link_new}
                                  clickHandler={(e) =>
                                    handlePopupToggle(e, setInvitePopupOpen)
                                  }
                                  mapFn={(member) =>
                                    member?.user?.fullName ||
                                    [
                                      member?.user?.firstName,
                                      member?.user?.lastName,
                                    ]
                                      .filter(Boolean)
                                      .join(" ")
                                  }
                                />
                              )}

                              {invitePopupOpen && (
                                <InviteesPopup
                                  position={invitePopupPosition}
                                  handleInvitePopupToggle={(e) =>
                                    handlePopupToggle(e, setInvitePopupOpen)
                                  }
                                  list={selectedStaff}
                                  showRoleAndOffice={true}
                                  isForEvent={true}
                                />
                              )}
                            </div>
                            {errors.staffMembers && (
                              <span className="error-msg">
                                {errors.staffMembers}
                              </span>
                            )}
                            {visibilityCardForAvailability && (
                              <div className={`p-3 mt-3 cbg-${stringValues}`}>
                                <div className="d-flex align-items-start gap-xxs">
                                  <img
                                    src={
                                      anyRepeatTypeActive
                                        ? InfoIcon
                                        : conflictingData?.isConflicting
                                          ? ErrorIcon
                                          : CircleIcon
                                    }
                                    alt="warning icon"
                                  />
                                  <div>
                                    <Text
                                      size="12px"
                                      weight="500"
                                      color="#111B45"
                                    >
                                      {t(
                                        `scheduler.${
                                          stringValues === "error" &&
                                          isInsideModal
                                            ? "dashboardError"
                                            : stringValues
                                        }MessageForAvailability`,
                                      )}
                                    </Text>
                                    {isInsideModal ? null : (
                                      <button
                                        className="border-0 bg-transparent"
                                        onClick={() =>
                                          manageTab(
                                            eventSchedulingTabStatus.schedulingAssistant,
                                          )
                                        }
                                      >
                                        <u className="cfs-xs">
                                          {t(
                                            "scheduler.viewSchedulingAssistant",
                                          )}
                                        </u>
                                      </button>
                                    )}
                                  </div>
                                </div>
                              </div>
                            )}
                          </div>
                          <div className="c-field">
                            <div
                              className={" d-flex justify-content-between  "}
                            >
                              <label className={styles["c-field-label"]}>
                                {t("roles")}
                              </label>
                              <span
                                className="link-btn"
                                onClick={() => {
                                  setIsSaveRolesModalOpen(true);
                                }}
                              >
                                {t("staff.select")}
                              </span>
                            </div>
                            <div
                              className="c-form-control "
                              style={{ position: "relative" }}
                            >
                              <span>
                                {filteredDesignationIds.length === 0 ? (
                                  t("accountOwner.noRolesSelected")
                                ) : (
                                  <MoreTagsFunction
                                    value={selectedRoleList}
                                    styles={styles.link_new}
                                    clickHandler={(e) =>
                                      handlePopupToggle(e, setRolePopupOpen)
                                    }
                                    mapFn={(member) => member?.name}
                                  />
                                )}
                              </span>
                              {rolePopupOpen && (
                                <RolePopup
                                  handlePopupToggle={(e) =>
                                    handlePopupToggle(e, setRolePopupOpen)
                                  }
                                  position={invitePopupPosition}
                                  list={selectedRoleList}
                                  isForEvent={true}
                                />
                              )}
                            </div>
                            {errors?.roles && (
                              <span className="error-msg">{errors.roles}</span>
                            )}
                          </div>

                          <div className="ch-checkbox c-field all-event-checkbox">
                            <label>
                              <input
                                type="checkbox"
                                defaultChecked={isAllDayEvent}
                                onChange={(e) =>
                                  handleChange("allDay", e.target.checked)
                                }
                              />
                              <span>
                                {t("accountOwner.allDayEvent", eventCapsKey)}
                              </span>
                            </label>
                          </div>
                          <div className="c-field">
                            <label>{t("accountOwner.date")}</label>
                            <div className="d-flex inputdate">
                              <ReactDatePickerCommon
                                dateFormat="dd-MM-yyyy"
                                className="c-form-control"
                                onChange={(e) => {
                                  setEventDate(e);
                                  setRepeatedEndDate(
                                    moment(e).add(3, "months").toDate(),
                                  );
                                }}
                                // minDate={new Date()}
                                selected={eventDate}
                              />
                            </div>
                          </div>
                          <Row>
                            <Col xs="6">
                              <div className="c-field">
                                <label>{t("start")}</label>
                                <TimePicker
                                  showSecond={false}
                                  placeholder="--"
                                  format="h:mm A"
                                  use12Hours
                                  onChange={(e) => {
                                    handleDateTimeChange("startTime", e);
                                  }}
                                  className="event-time-picker"
                                  disabled={isAllDayEvent}
                                  value={startTime}
                                  minuteStep={1}
                                />
                                {errors.startTime && (
                                  <span className="error-msg">
                                    {errors.startTime}
                                  </span>
                                )}
                              </div>
                            </Col>
                            <Col xs="6">
                              <div className="c-field">
                                <label>{t("end")}</label>
                                <TimePicker
                                  showSecond={false}
                                  placeholder="--"
                                  format="h:mm A"
                                  use12Hours
                                  onChange={(e) => {
                                    handleDateTimeChange("endTime", e);
                                  }}
                                  className={["event-time-picker"]}
                                  disabled={isAllDayEvent}
                                  value={endTime}
                                  minuteStep={1}
                                />
                                {(errors.endTime && (
                                  <span className="error-msg">
                                    {errors.endTime}
                                  </span>
                                )) ||
                                  (endTimeError && (
                                    <span className="error-msg">
                                      {endTimeError}
                                    </span>
                                  ))}
                              </div>
                            </Col>
                          </Row>
                          <div className="c-field">
                            <label>{t("repeat")}</label>
                            <div className="custom-dropdown-only">
                              <CustomDropdown
                                options={repeatOptions}
                                selectedOption={repeatedType}
                                selectOption={(id) => {
                                  setRepeatedType(id);
                                }}
                              />
                            </div>
                          </div>

                          {isCustom && (
                            <RepeatEventDropDowns
                              selectionType={selectionType}
                              selectedSlotDate={selectedSlotDate}
                              selectedWeek={selectedWeek}
                              selectedDay={selectedDay}
                              selectedMonths={selectedMonths}
                              isDaySwitchOn={isDaySwitchOn}
                              repeatedTypeEvery={repeatedTypeEvery}
                              repeatedTypeFrequency={repeatedTypeFrequency}
                              setSchedule={setSchedule}
                              eventOrShiftTab={eventOrShiftTab}
                              setSelectedMonths={setSelectedMonths}
                              setSelectedSlotDate={setSelectedSlotDate}
                              schedule={schedule}
                              setRepeatedTypeEvery={setRepeatedTypeEvery}
                              setRepeatedTypeFrequency={
                                setRepeatedTypeFrequency
                              }
                              setSelectionType={setSelectionType}
                              setSelectedWeek={setSelectedWeek}
                              setSelectedDay={setSelectedDay}
                              setIsDaySwitchOn={setIsDaySwitchOn}
                            />
                          )}
                          {anyRepeatTypeActive && (
                            <div className="ch-checkbox c-field all-event-checkbox d-flex gap-sm mt-3">
                              {excludeCheckBox.map((boxes) => {
                                return (
                                  <label
                                    key={boxes.key}
                                    htmlFor={boxes.key}
                                    className="position-relative"
                                  >
                                    <input
                                      type="checkbox"
                                      id={boxes.key}
                                      checked={exclude[boxes.key]}
                                      onChange={(e) => {
                                        setExclude((prev) => {
                                          return {
                                            ...prev,
                                            [boxes.key]: e.target.checked,
                                          };
                                        });
                                      }}
                                    />
                                    <span>{boxes.heading}</span>
                                  </label>
                                );
                              })}
                            </div>
                          )}
                          {anyRepeatTypeActive && (
                            <div className="c-field mt-4">
                              <label>
                                {t("accountOwner.endDateRepeatedEvents", {
                                  eventOrShift: t(
                                    `accountOwner.${
                                      eventOrShiftTab ? "shift" : "event"
                                    }s`,
                                  ),
                                })}
                              </label>
                              <div className="d-flex inputdate">
                                <ReactDatePickerCommon
                                  dateFormat="dd-MM-yyyy"
                                  className="c-form-control"
                                  onChange={(e) => {
                                    setRepeatedEndDate(e);
                                  }}
                                  minDate={eventDate}
                                  selected={repeatedEndDate}
                                />
                              </div>
                              {errors?.repeatedEndDate && (
                                <span className="error-msg">
                                  {errors.repeatedEndDate}
                                </span>
                              )}
                            </div>
                          )}

                          {eventTabCheck && (
                            <>
                              <div className="c-field mt-3">
                                <label>{t("location")}</label>
                                <textarea
                                  className="c-form-control"
                                  placeholder={t("form.placeholder1", {
                                    field: t("location"),
                                  })}
                                  name="location"
                                  maxLength="400"
                                  value={eventLocation}
                                  onChange={(e) => {
                                    handleChange(
                                      "eventLocation",
                                      e.currentTarget.value,
                                    );
                                    setEventLocation(e.currentTarget.value);
                                  }}
                                ></textarea>
                                {errors.eventLocation && (
                                  <span className="error-msg">
                                    {errors.eventLocation}
                                  </span>
                                )}
                              </div>

                              {eventTabCheck && (
                                <div className="c-field">
                                  <label>
                                    {t("accountOwner.blockTimeslotAallDoctors")}
                                  </label>
                                  <div className="ch-radio">
                                    <label
                                      className="mr-5"
                                      onClick={() => setBlockForPatient(true)}
                                    >
                                      <input
                                        type="radio"
                                        name="blockTimeslotAallDoctors"
                                        checked={blockForPatient}
                                      />
                                      <span> {t("superAdmin.yes")} </span>
                                    </label>
                                    <label
                                      onClick={() => setBlockForPatient(false)}
                                    >
                                      <input
                                        type="radio"
                                        name="blockTimeslotAallDoctors"
                                        checked={!blockForPatient}
                                      />
                                      <span>{t("superAdmin.no")}</span>
                                    </label>
                                  </div>
                                </div>
                              )}
                              <div className="c-field">
                                <label>{t("accountOwner.notes")}</label>
                                <textarea
                                  className="c-form-control"
                                  placeholder={t("form.placeholder1", {
                                    field: t("accountOwner.notes"),
                                  })}
                                  name="Notes"
                                  maxLength="1000"
                                  value={note}
                                  onChange={(e) => {
                                    if (testRegexCheck(e.currentTarget.value)) {
                                      handleChange(
                                        "note",
                                        e.currentTarget.value,
                                      );
                                      setNote(e.currentTarget.value);
                                    }
                                  }}
                                ></textarea>
                                {errors.note && (
                                  <span className="error-msg">
                                    {errors.note}
                                  </span>
                                )}
                              </div>
                              <div className="c-field">
                                <div
                                  className={
                                    " d-flex justify-content-between  "
                                  }
                                >
                                  <label className={styles["c-field-label"]}>
                                    {t("accountOwner.tags")}
                                  </label>
                                  {eventTags?.length > 0 && (
                                    <span
                                      className="link-btn"
                                      type="button"
                                      data-testid="button-clearAll"
                                      onClick={clearAllTags}
                                    >
                                      {t("accountOwner.clearAll")}
                                    </span>
                                  )}
                                </div>
                                <CustomInputTag
                                  tagslist={eventTags}
                                  setTagslist={(value) => setEventTags(value)}
                                />
                              </div>
                            </>
                          )}
                          <div className="c-field">
                            <label>
                              {t("scheduler.notifyAttendees", eventCapsKey)}
                            </label>
                            <div className="custom-dropdown-only">
                              <CustomDropdown
                                options={
                                  isAllDayEvent
                                    ? notifyAttendeesOptionsForAllDayEvent(
                                        eventOrShiftTab,
                                      )
                                    : notifyAttendeesOptions
                                }
                                selectedOption={notifyDuration}
                                selectOption={(id) => {
                                  setNotifyDuration(id);
                                }}
                                matchWithOther={[0]}
                              />
                            </div>
                          </div>
                          <div className="c-field mb-3">
                            <label>
                              {t(
                                "accountOwner.publishEventHeadingSelection",
                                eventCapsKey,
                              )}
                            </label>
                            <div className="custom-dropdown-only">
                              <CustomDropdown
                                options={preferredOption.dropdown}
                                selectedOption={publishAsEvent}
                                selectOption={(id) => {
                                  setPublishAsEvent(id);
                                }}
                              />
                            </div>
                          </div>

                          {preferredOption.dropdown[
                            filteredUserIds?.length ? 1 : 0
                          ].id === publishAsEvent && (
                            <>
                              <div className={styles["other-options-main"]}>
                                <div className={"c-field mb-0 pb-3"}>
                                  <label>
                                    {t("scheduler.whoElseCanJoin", eventKey)}
                                  </label>
                                </div>
                                {preferredOption.otherOptions?.map(
                                  (otherOption, ind, currArr) => {
                                    const selected =
                                      otherOption.id === nonInviteesPublish;
                                    if (ind === currArr.length - 1) {
                                      return (
                                        <div
                                          className={
                                            "c-field mb-0" +
                                            (selected
                                              ? " " + styles["checked-field"]
                                              : "")
                                          }
                                          key={otherOption.title}
                                        >
                                          <div
                                            className={
                                              "d-flex justify-content-between align-items-center ch-radio"
                                            }
                                          >
                                            <label
                                              className={
                                                styles["c-field-label"]
                                              }
                                            >
                                              <input
                                                type="radio"
                                                name={otherOption.id}
                                                checked={selected}
                                                onChange={() =>
                                                  setNonInviteesPublish(
                                                    otherOption.id,
                                                  )
                                                }
                                              />
                                              <span>{otherOption.title}</span>
                                            </label>

                                            <small
                                              className={`${
                                                styles.link_new
                                              } link-btn ${
                                                !selected ? "disabled" : ""
                                              }`}
                                              onClick={() => {
                                                if (selected) {
                                                  setIsSelectOfficeModalOpen(
                                                    "select",
                                                  );
                                                }
                                              }}
                                            >
                                              {t("accountOwner.selectOffices")}
                                            </small>
                                          </div>

                                          <div
                                            className={
                                              "c-form-control " +
                                              styles.link_new
                                            }
                                            style={{
                                              position: "relative",
                                            }}
                                          >
                                            {officeIdForNonInvitee?.length ===
                                            0 ? (
                                              <small
                                                className={`${
                                                  !selected ? "disabled" : ""
                                                }`}
                                              >
                                                {t(
                                                  "accountOwner.noOfficeSelected",
                                                )}
                                              </small>
                                            ) : (
                                              <MoreTagsFunction
                                                value={officeIdForNonInvitee}
                                                styles={styles.link_new_btn}
                                                clickHandler={(e) =>
                                                  handlePopupToggle(
                                                    e,
                                                    setNonInvitePopup,
                                                  )
                                                }
                                                mapFn={(member) => member?.name}
                                              />
                                            )}
                                            {nonInvitePopup && selected && (
                                              <InviteesPopup
                                                position={invitePopupPosition}
                                                handleInvitePopupToggle={(e) =>
                                                  handlePopupToggle(
                                                    e,
                                                    setNonInvitePopup,
                                                  )
                                                }
                                                list={officeIdForNonInvitee}
                                                showRoleAndOffice={false}
                                                isForEvent={true}
                                                onlyOfffice
                                                isfromBusySlot
                                              />
                                            )}
                                            {errors.nonInvitee && (
                                              <small className="error-msg">
                                                {errors.nonInvitee}
                                              </small>
                                            )}
                                          </div>
                                        </div>
                                      );
                                    }

                                    return (
                                      <div className="position-relative overflow-visible">
                                        <label
                                          className={
                                            styles["c-field-label"] +
                                            " w-100 ch-radio " +
                                            styles["radio_btn_border"] +
                                            (selected
                                              ? " " + styles["checked-field"]
                                              : "")
                                          }
                                        >
                                          <input
                                            type="radio"
                                            name={otherOption.id}
                                            checked={
                                              otherOption.id ===
                                              nonInviteesPublish
                                            }
                                            onChange={() => {
                                              setNonInviteesPublish(
                                                otherOption.id,
                                              );
                                              if (
                                                officeIdForNonInvitee?.length
                                              ) {
                                                setOfficeIdForNonInvitee([]);
                                              }
                                            }}
                                          />
                                          <span className="mb-2 mt-2">
                                            {otherOption.title}
                                          </span>
                                          {filteredUserIds.length > 0 &&
                                            !ind &&
                                            selected && (
                                              <div
                                                className={
                                                  styles["office-names"] +
                                                  " remove_radio_from_span mt-2 cfs-sm"
                                                }
                                              >
                                                <MoreTagsFunction
                                                  value={Array.from(
                                                    new Map(
                                                      filteredUserIds.map(
                                                        (user) => [
                                                          user.office.id,
                                                          user.office,
                                                        ],
                                                      ),
                                                    ).values(),
                                                  )}
                                                  styles={styles.link_new_btn}
                                                  mapFn={(office) =>
                                                    office?.name
                                                  }
                                                  clickHandler={(e) =>
                                                    handlePopupToggle(
                                                      e,
                                                      setNonInvitePopup,
                                                    )
                                                  }
                                                />
                                              </div>
                                            )}
                                        </label>

                                        {nonInvitePopup && selected && (
                                          <InviteesPopup
                                            position={invitePopupPosition}
                                            handleInvitePopupToggle={(e) =>
                                              handlePopupToggle(
                                                e,
                                                setNonInvitePopup,
                                              )
                                            }
                                            list={Array.from(
                                              new Map(
                                                filteredUserIds.map((user) => [
                                                  user.office.id,
                                                  user.office,
                                                ]),
                                              ).values(),
                                            )}
                                            showRoleAndOffice={false}
                                            isForEvent={true}
                                            onlyOfffice
                                            isfromBusySlot
                                          />
                                        )}
                                      </div>
                                    );
                                  },
                                )}
                              </div>
                              {eventTabCheck && (
                                <div className="ch-checkbox c-field all-event-checkbox margin30">
                                  <label>
                                    <input
                                      type="checkbox"
                                      defaultChecked={isAutoMatically}
                                      onChange={() =>
                                        setIsAutoMatically(!isAutoMatically)
                                      }
                                    />
                                    <span>
                                      {t("accountOwner.automacticallyAccept")}
                                    </span>
                                  </label>
                                </div>
                              )}
                            </>
                          )}
                          <div
                            className={
                              "add-event-btn-box-new" +
                              (isInsideModal
                                ? " " + styles["modal-bottom-view"]
                                : "")
                            }
                          >
                            <button
                              className="button button-round button-shadow text-capitalize"
                              title={t("accountOwner.addEvent", eventKey)}
                              disabled={
                                !selectedStaff?.length &&
                                !designationIds?.length &&
                                publishAsEvent !==
                                  preferredOption.dropdown[
                                    preferredOption.dropdown.length - 1
                                  ].id
                              }
                              onClick={() => saveEvent()}
                            >
                              {t("accountOwner.addEvent", eventKey)}
                            </button>
                            <button
                              className="button button-round button-dark button-border"
                              title={t("cancel")}
                              onClick={() => {
                                if (onConfirm) {
                                  onConfirm(false);
                                } else {
                                  goBack();
                                }
                              }}
                            >
                              {t("cancel")}
                            </button>
                          </div>
                        </div>
                      </div>
                      {isInsideModal ? null : (
                        <div className={styles.scheduling_right_section}>
                          <div className={styles.image_text_wrap}>
                            <img
                              src={SchedulingAssistant}
                              alt="scheduling assistant"
                              className={styles.scheduling_assistant_img}
                            />
                            <Text size="20px" weight="500" color="#111B45">
                              Need to find a time that works for everyone?
                            </Text>
                            <Text size="20px" weight="500" color="#111B45">
                              Switch to the 'Scheduling Assistant' tab at the
                              top right to get started.
                            </Text>
                          </div>
                        </div>
                      )}
                    </div>
                  )}
                </TabPane>
                <TabPane tabId={2}>
                  {activeTab ===
                    eventSchedulingTabStatus.schedulingAssistant && (
                    <SchedulingAssistantDetails
                      eventDate={eventDate}
                      setEventDate={setEventDate}
                      startTime={startTime}
                      setStartTime={setStartTime}
                      endTime={endTime}
                      today={today}
                      setEndTime={setEndTime}
                      isAllDayEvent={isAllDayEvent}
                      setIsAllDayEvent={setIsAllDayEvent}
                      endTimeError={endTimeError}
                      handleDateTimeChange={handleDateTimeChange}
                      errors={errors}
                      eventKey={eventKey}
                      options={repeatOptions}
                      selectedOption={repeatedType}
                      disabledDates={disabledDates}
                      repeatMessagesDisplay={repeatMessagesDisplay}
                      selectOption={(id) => {
                        setRepeatedType(id);
                      }}
                      prevSelectedValues={{
                        schedule,
                        selectedMonths,
                        selectedSlotDate,
                        repeatedTypeEvery,
                        repeatedTypeFrequency,
                        selectionType,
                        selectedWeek,
                        selectedDay,
                        isDaySwitchOn,
                      }}
                      setRepeatTypeValues={(values) => {
                        setSchedule(values.schedule);
                        setSelectedMonths(values.selectedMonths);
                        setSelectedSlotDate(values.selectedSlotDate);
                        setRepeatedTypeEvery(values.repeatedTypeEvery);
                        setRepeatedTypeFrequency(values.repeatedTypeFrequency);
                        setSelectionType(values.selectionType);
                        setSelectedWeek(values.selectedWeek);
                        setSelectedDay(values.selectedDay);
                        setIsDaySwitchOn(values.isDaySwitchOn);
                      }}
                      eventOrShiftTab={eventOrShiftTab}
                      selectedStaff={selectedStaff}
                      setSelectedStaff={setSelectedStaff}
                      ownerId={loggedInUserId}
                      manageTab={manageTab}
                      eventSchedulingTabStatus={eventSchedulingTabStatus}
                    />
                  )}
                </TabPane>
              </Suspense>
            </TabContent>
          </div>
        </div>
      </div>
      {issaveRolesModalOpen && (
        <AddRolesModal
          issaveRolesModalOpen={issaveRolesModalOpen}
          setIsSaveRolesModalOpen={setIsSaveRolesModalOpen}
          designationIds={designationIds}
          setDesignationIds={setDesignationIds}
          userRoles={roleData ? roleData : []}
        />
      )}
      {confirmPopup && (
        <ConfirmationPopup
          t={t}
          isModalOpen={confirmPopup}
          closeModal={closeModal}
          handleConfirm={handleConfirm}
          id={
            !filteredUserIds.length &&
            preferredOption.dropdown[0].id === publishAsEvent
              ? "userNotselectedAllowInvitees"
              : publishAsEvent
          }
          loader={loader}
          eventKey={eventKey}
        />
      )}

      {isSelectStaffMemberModalOpen && (
        <SelectStaffMemberModal
          isOpen={isSelectStaffMemberModalOpen}
          closeStepOneModal={setIsSelectStaffMemberModalOpen}
          ownerId={loggedInUserId}
          setMemberIds={setUserIds}
          memberIds={userIds}
          eventOrShiftTab={eventOrShiftTab}
          canAddShift={isStaff && eventOrShiftTab}
          selectedStaff={selectedStaff}
          IsOwnerInclude={true}
          setSelectedStaff={setSelectedStaff}
        />
      )}
      {!!isSelectOfficeModalOpen && (
        <SelectOfficeModal
          isOpen={!!isSelectOfficeModalOpen}
          closeStepOneModal={setIsSelectOfficeModalOpen}
          ownerId={loggedInUserId}
          setMemberIds={(value) => {
            if (errors.nonInvitee && value?.length) {
              setErrors((prev) => {
                delete prev.nonInvitee;
                return {
                  ...prev,
                };
              });
            }
            if (
              eventOrShiftTab &&
              !selectOfficeForEvent &&
              value?.length === 1
            ) {
              setSelectOfficeForEvent(value[0]);
            }
            setOfficeIdForNonInvitee(value);
          }}
          memberIds={officeIdForNonInvitee}
          fromSelectOffice={isSelectOfficeModalOpen === "select"}
          canAddShift={isStaff && eventOrShiftTab}
          selectOfficeForEvent={selectOfficeForEvent}
          setSelectOfficeForEvent={setSelectOfficeForEvent}
          eventCapsKey={eventCapsKey}
          callConfirm={() => {
            setIsSelectOfficeModalOpen("");
            saveEvent(true);
          }}
        />
      )}
      {isScheduleAssistantInfoModalOpen && (
        <SchedulerAssistantInfoModal
          isOpen={isScheduleAssistantInfoModalOpen}
          onClose={setIsScheduleAssistantInfoModalOpen}
          isShift={eventOrShiftTab}
          eventKey={eventKey}
          activeTab={activeTab}
        />
      )}
    </Page>
  );
};

export default withTranslation()(AddEvent);
